<template>
    <div>
        <transition name="el-zoom-in-center">
            <el-card v-show="add.addshow" class="box-card" style="text-align: left">
                <div slot="header" class="clearfix">
                    <el-row>
                        <el-col :span="12">
                            <h3>{{ form.id ? '编辑调拨出库' : '新增调拨出库' }}</h3>
                        </el-col>
                        <el-col :span="12">
                            <el-button style="float: right" type="primary" @click="add.addshow = false">收起</el-button>
                        </el-col>
                    </el-row>
                </div>
                <el-form ref="form" :model="form" label-width="110px" style="width: 100%" :rules="rules">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="发货仓库" prop="outWarehouseCode">
                                <el-select v-model.trim="form.outWarehouseCode" placeholder="请输入仓库名称" style="width:100%"
                                    filterable>
                                    <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                                        :label="item.warehouseName" :value="item.warehouseCode" />
                                </el-select>
                                <!-- <el-input v-model="form.productName" style="width: 50%" disabled placeholder="请选择产品" /> -->
                                <!-- <el-button :disabled="!form.companyID" @click="getProductList()">选择</el-button> -->
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="收货仓库" prop="inWarehouseCode">
                                <el-select v-model.trim="form.inWarehouseCode" placeholder="请输入仓库名称" style="width:100%"
                                    filterable>
                                    <el-option v-for="item in pagewarehouse" :key="item.warehouseCode"
                                        :label="item.warehouseName" :value="item.warehouseCode" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="运单号" prop="trackingNo">
                                <el-input v-model="form.trackingNo" style="width: 90%" placeholder="请输入运单号" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="调拨日期" prop="transferDate" label-width="120px">
                                <el-date-picker v-model="form.transferDate" type="date" value-format="yyyy-MM-dd"
                                    placeholder="选择调拨日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item label="备注" prop="remark">
                                <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.remark" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div>
                    <!-- 填写具体奖项 -->
                    <h4>产品记录</h4>
                    <br />
                    <el-row>
                        <el-col :span="11">
                            <el-card shadow="never">
                                <el-form ref="detailList" :model="detailList" label-width="140px" style="width: 80%"
                                    :rules="rules">
                                    <el-form-item label="产品" prop="productCode">
                                        <el-select @change="selectCode" v-model.trim="detailList.productCode"
                                            placeholder="请选择产品" style="width:70%" filterable>
                                            <el-option v-for="item in productlist" :key="item.product_code"
                                                :label="item.product_name" :value="item.product_code" />
                                        </el-select>
                                        <!-- <el-input v-model="detailList.product_code" style="width: 70%"
                                        placeholder="请输入产品SKU编码" /> -->
                                    </el-form-item>
                                    <!-- <el-form-item label="产品名称" prop="productName">
                                    <el-input v-model="detailList.productName" style="width: 70%" placeholder="请输入产品名称" />
                                </el-form-item> -->
                                    <el-form-item label="批次号" prop="batchNo">
                                        <el-input v-model="detailList.batchNo" style="width: 70%"
                                            placeholder="请输入批次号" />
                                    </el-form-item>
                                    <!-- <el-form-item label="箱码" prop="boxCode">
                                    <el-input v-model="detailList.boxCode" style="width: 70%" placeholder="请输入箱码" />
                                </el-form-item> -->
                                    <el-form-item label="计划生产数量" prop="planQuantity">
                                        <el-input v-model.number="detailList.planQuantity" style="width: 70%"
                                            placeholder="请输入计划生产数量" />
                                    </el-form-item>
                                </el-form>
                                <div style="text-align: center">
                                    <el-button style="margin-top: 12px" @click="resetForm()">重置</el-button>
                                    <el-button style="margin-top: 12px" type="primary"
                                        @click="productadd('detailList')">生成</el-button>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="2" style="text-align: center">
                            <el-button @click="productadd('detailList')" size="medium" style="margin-top: 100px"
                                class="el-icon-d-arrow-right" />
                        </el-col>
                        <el-col :span="11">
                            <el-card shadow="never">
                                <el-table :data="tablelist" stripe style="width: 100%" height="224">
                                    <!-- <el-table-column prop="product_code" label="产品SKU编码" show-overflow-tooltip /> -->
                                    <el-table-column prop="productName" label="产品名称" show-overflow-tooltip />
                                    <el-table-column prop="batchNo" label="批次号" show-overflow-tooltip />
                                    <!-- <el-table-column prop="boxCode" label="箱码" min-width="100" /> -->
                                    <el-table-column prop="planQuantity" label="计划生产数量" min-width="100" />
                                    <el-table-column prop="address" label="操作" width="80" fixed="right">
                                        <template slot-scope="scope">
                                            <el-button-group>
                                                <el-button type="danger" @click.native.prevent="
                                                    deleteRow(scope.$index, tablelist)
                                                    ">删除</el-button>
                                            </el-button-group>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>
                        </el-col>
                    </el-row>
                    <div style="text-align: center">
                        <el-button style="margin-top: 12px" type="primary" @click="submitadd('form')">提交</el-button>
                    </div>
                </div>
            </el-card>
        </transition>
        <el-dialog title="调拨明细" :visible.sync="dialogShow" width="60%" :close-on-click-modal="false"
            :modal-append-to-body='true'>
            <div style="margin-bottom: 10px;">
                <el-button v-permission="['transferOutOrder_update']" type="primary" @click="handleAllSelect()">
                    批量完成调拨</el-button>
            </div>
            <!-- 填写基础信息 -->
            <el-table row-key="id" ref="multipleTable" @selection-change="handleSelectionChange"
                :data="transferOrderNoList" style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="transferOrderNo" label="调拨单号" min-width="150" />
                <el-table-column prop="productCode" label="产品编码" min-width="150" />
                <el-table-column prop="productName" label="产品名称" min-width="250" />
                <el-table-column prop="scannedQuantity" label="扫描数量" min-width="80" />
                <el-table-column prop="actualQuantity" label="确认数量" min-width="80" />
                <el-table-column prop="unitName" label="单位" min-width="80" />
                <el-table-column min-width="180" label="操作">
                    <template slot-scope="scope">
                        <!-- v-if="scope.row.status == 5" -->
                        <el-button v-permission="['transferOutOrder_update']" type="primary"
                            @click="handleSuccess(scope.row)"> 完成调拨</el-button>
                        <el-button v-if="scope.row.status == 0" v-permission="['transferOutOrder_delete']" type="danger"
                            @click="deletedate(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="dialogShow = false">取消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="调拨明细" :visible.sync="dialogDetailShow" width="50%" :close-on-click-modal="false"
            :modal-append-to-body='true'>
            <!-- 填写基础信息 -->
            <el-table :data="multipleSelection" style="width: 100%">
                <el-table-column prop="transferOrderNo" label="调拨单号" min-width="150" />
                <el-table-column prop="productCode" label="产品编码" min-width="150" />
                <el-table-column prop="productName" label="产品名称" min-width="250" />
                <el-table-column prop="scannedQuantity" label="扫描数量" min-width="80" />
                <el-table-column prop="actualQuantity" label="确认数量" min-width="80" />
                <el-table-column prop="unitName" label="单位" min-width="80" />
                <el-table-column label="调拨数量" min-width="80">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.inputNum" placeholder="请输入" />
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-button style="margin-top: 12px" @click="dialogDetailShow = false">取消</el-button>
                <el-button v-permission="['transferOutOrder_update']" type="primary" @click="handleSelectSuccess()">
                    完成调拨</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    transferAdd,
    transferUpdate,
    transferDetail,
    transferConfirmDetail,
    transferConfirmAllDetail,
    transferDelete,
} from "@/api/production";
import { pagewarehouse } from "@/api/query";
import { productlist, } from "@/api/base";
export default {
    props: {
        search: {
            type: Function,
            default: null,
        },
        add: {
            type: Object,
            default: () => {
                return {
                    addshow: null,
                };
            },
        },
    },
    data() {
        return {
            multipleSelection: [],
            dialogShow: false,
            dialogDetailShow: false,
            transferOrderNo: null,
            productlist: [], // 产品列表下拉
            pagewarehouse: [],
            transferOrderNoList: [],
            form: {
                inWarehouseCode: null,
                outWarehouseCode: null,
                trackingNo: null,
                transferDate: null,
            },
            detailList: {
                batchNo: null,
                // boxCode: null,
                planQuantity: null,
                productCode: null,
                productName: null
            },
            // 步骤2表格数据
            tablelist: [],
            rules: {
                outWarehouseCode: [
                    { required: true, message: "请选择发货仓库", trigger: "blur" },
                ],
                inWarehouseCode: [
                    { required: true, message: "请选择收货仓库", trigger: "blur" },
                ],
                productCode: [
                    { required: true, message: "请输入产品编码", trigger: "blur" },
                    { validator: this.$validateaccount, trigger: "blur" },
                ],

                transferDate: [
                    { required: true, message: "请选择调拨日期", trigger: "blur" },
                ],
                productName: [
                    { required: true, message: "请输入产品名称", trigger: "blur" },
                ],
                planQuantity: [
                    {
                        required: true,
                        message: "请输入计划生产数量",
                        trigger: "blur",
                        type: "number",
                    },
                ],
            },
        };
    },
    mounted() {
        this.getproductlist(); // 产品下拉
    },
    methods: {
        handleSelectionChange(list) {
            this.multipleSelection = list.filter(item => {
                this.$set(item, 'inputNum', item.scannedQuantity)
                return item.status === 0 || item.status === 5
            })
            console.log(this.multipleSelection, ' this.multipleSelection');
        },
        handleAllSelect() {
            if (this.multipleSelection.length > 0) {
                this.dialogDetailShow = true
            } else {
                this.$message({
                    type: "warning",
                    message: "请选择调拨单",
                });
            }
        },
        // 获取产品下拉
        async getproductlist(value) {
            const params = {
                pageIndex: 1,
                pageSize: 999,
            }
            const { data } = await productlist({ productName: value })
            this.productlist = data.data;
            //仓库 
            const { data: list } = await pagewarehouse(params)
            this.pagewarehouse = list.list
        },
        // 把产品添加到表格
        productadd(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {};
                    obj = Object.assign({}, this.detailList)
                    for (let i = 0; i < this.tablelist.length; i++) {
                        // 产品不能重复
                        if (
                            this.tablelist[i].productCode == this.detailList.product_code
                        ) {
                            this.tablelist[
                                i
                            ].planQuantity += this.detailList.planQuantity;
                            this.$refs[formName].resetFields();
                            return;
                        }
                    }
                    this.tablelist.push(obj);
                    this.$refs[formName].resetFields();
                }
            });
        },
        // 表格行删除
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        // 保存提交
        submitadd(formName) {
            this.$refs[formName].validate((valid) => {
                // 基础表单验证
                if (valid) {
                    if (this.tablelist.length == 0) {
                        this.$message({
                            type: "warning",
                            message: "请添加产品",
                        });
                        return
                    }
                    if (this.form.id) {
                        transferUpdate({
                            ...this.form,
                            detailList: this.tablelist,
                        }).then((response) => {
                            this.$message({
                                type: "success",
                                message: "修改成功!",
                            });
                            this.search();
                            this.tablelist = [];
                            this.resetForm();
                            this.add.addshow = false;
                        });
                    } else {
                        transferAdd({
                            ...this.form,
                            detailList: this.tablelist,
                        }).then((response) => {

                            this.$message({
                                type: "success",
                                message: "添加成功!",
                            });
                            this.search();
                            this.tablelist = [];
                            this.resetForm();
                            this.add.addshow = false;
                        });
                    }
                }
            });
        },
        // 清空表单数据
        resetForm() {
            this.tablelist = []
            this.form = {}
        },
        selectCode(code) {
            const arr = this.productlist.filter(item => item.product_code == code)[0]
            this.detailList.productName = arr.product_name
        },
        getDetailList(transferOrderNo) {
            this.transferOrderNo = transferOrderNo
            transferDetail({ transferOrderNo }).then(res => {
                this.transferOrderNoList = res.data.detailList
                this.dialogShow = true
            }).catch(() => {
                this.transferOrderNoList = []
            })
        },
        handleSuccess(data) {
            this.$prompt('请输入实际调拨总数量', '提示', {
                inputValue: data.scannedQuantity,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    if (!value) {
                        return '请填写实际调拨总数量';
                    }
                },
            }).then(({ value }) => {
                const parms = {
                    detailId: data.id,
                    actualQuantity: value
                }
                transferConfirmDetail(parms).then(res => {
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    });
                    this.getDetailList(this.transferOrderNo)
                    // this.dialogShow = false
                    // this.$parent.search()
                })
            })
        },
        // 删除按钮事件
        deletedate(row) {
            this.$confirm("此操作将永久删除该调拨单, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    transferDelete({ transferOrderNo: row.transferOrderNo }).then((response) => {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getDetailList(this.transferOrderNo)
                    });
                })
        },
        handleSelectSuccess() {
            const list = this.multipleSelection.filter(item => item.inputNum <= 0)
            if (list.length) {
                this.$message({
                    type: "warning",
                    message: "请填写完整调拨数量",
                });
                return
            }
            const details = this.multipleSelection.map(item => {
                return {
                    DetailId: item.id,
                    ActualQuantity: Number(item.inputNum)
                }
            })
            console.log(details, 'details');
            transferConfirmAllDetail(details).then((response) => {
                this.$message({
                    type: "success",
                    message: "操作成功!",
                });
                this.getDetailList(this.transferOrderNo)
                this.dialogDetailShow = false
            });

        },
    },
};
</script>